<template>
  <div class="popup">
    <div class="popup__overlay" @click="$emit('close-popup')"></div>
    <div class="popup__content">
      <div class="popup__close-btn" @click="$emit('close-popup')"></div>
      <div class="popup__title" v-html="data.title[lang]">
      </div>
      <div class="popup__text" v-html="data.text[lang]"/>
      <i :class="`popup__icon popup__icon--${data.type}`"></i>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  props: ["data"],
  computed: {
    ...mapState(["lang"])
  }
};
</script>

<style lang="scss" scoped>
.popup {
  position: fixed;
  display: flex;
  align-content: center;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  overflow: auto;
  z-index: 11;

  &__overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }

  &__close-btn {
    position: absolute;
    right: -70px;
    top: 0;
    width: 40px;
    height: 40px;
    cursor: pointer;

    &::after {
      content: '';
      position: absolute;
      width: 45px;
      height: 3px;
      background: #ffffff;
      transform: translate(-50%, -50%) rotate(-45deg);
      top: 50%;
      left: 50%;
    }

    &::before {
      content: '';
      position: absolute;
      width: 45px;
      height: 3px;
      background: #ffffff;
      transform: translate(-50%, -50%) rotate(45deg);
      top: 50%;
      left: 50%;
    }
  }

  &__content {
    position: relative;
    display: inline-block;
    background: #ffffff;
    padding: 30px;
    align-self: center;
    max-width: 1000px;
    text-align: left;
    padding: 50px 100px;
  }

  &__title {
    font-size: 36px;
    margin-bottom: 20px;
    text-transform: uppercase;
    color: #004169;
    font-weight: 700;
  }

  &__text {
    font-size: 28px;
  }

  &__icon {
    position: absolute;
    top: -86px;
    left: -78px;
    width: 172px;
    height: 157px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;

    &--ai {
      background-image: url("../assets/marks/MARK_-_AI.svg");
    }

    &--digital-infrastructure {
      background-image: url("../assets/marks/MARK_-_Digital_Infrastructure.svg");
    }

    &--environment {
      background-image: url("../assets/marks/MARK_-_Enviroment.svg");
    }

    &--good-work {
      background-image: url("../assets/marks/MARK_-_Good_Work.svg");
    }

    &--regulation {
      background-image: url("../assets/marks/MARK_-_Regulation.svg");
    }

    &--security {
      background-image: url("../assets/marks/MARK_-_Security.svg");
    }

    &--social {
      background-image: url("../assets/marks/MARK_-_Social.svg");
    }

    &--standards {
      background-image: url("../assets/marks/MARK_-_Standards.svg");
    }

    &--technology {
      background-image: url("../assets/marks/MARK_-_Technology.svg");
    }
  }
}
</style>
